import workOrder from './modules/work-order'

const modules = [
  workOrder
]

export const reset = ({ dispatch }) => {
  modules.forEach((module) => {
    dispatch(`${module}/reset`)
  })
}
